import React from "react";

const TopBanner = ({ masterConfigKey }) => {
  const sponsorUrls = masterConfigKey?.sponsorUrls;

  // [
  //   "https://gov.mp.in",         // Government of MP
  //   "https://sageuniversity.in", // SAGE University
  //   "https://meghdoot.com",      // Meghdoot
  // ];

  return (
    <>
      {masterConfigKey && (
        <div className="relative w-full">
          {/* Desktop Banner */}
          <img
            src={masterConfigKey?.desktopBannerUrl}
            alt="sponsor"
            className="hidden md:block w-full h-full"
          />

          {/* Mobile Banner */}
          <img
            src={masterConfigKey?.mobileBannerUrl}
            alt="sponsor"
            className="block md:hidden w-full h-full"
          />

          {/* Sponsor clickable overlays */}
          {sponsorUrls && sponsorUrls.length > 0 && (
            <>
              <a
                href={sponsorUrls[0]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-[60%] w-[45%] h-full md:hidden"
              />

              <a
                href={sponsorUrls[1]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-[30%] w-[30%] h-full md:hidden"
              />

              <a
                href={sponsorUrls[2]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-0 w-[30%] h-full md:hidden"
              />
            </>
          )}

          {/* Desktop overlays   */}
          {sponsorUrls && sponsorUrls.length > 0 && (
            <>
              <a
                href={sponsorUrls[0]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-[28%] w-[28%] h-full hidden md:block"
              />
              <a
                href={sponsorUrls[1]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-[10%] w-[20%] h-full hidden md:block"
              />
              <a
                href={sponsorUrls[2]}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-0 right-0 w-[10%] h-full hidden md:block"
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default TopBanner;
